function calcProductPrice() {
    let {oldPrice, price, quantity, cur} = window
    let totalPrice = price * quantity
    let totalOldPrice = oldPrice * quantity
    let totalEconomy = totalOldPrice - totalPrice

    let appendCalcedPrice = document.querySelectorAll('.append-calced-price')
    let appendCalcedOldPrice = document.querySelectorAll('.append-calced-old-price')
    let appendCalcedEconomy = document.querySelectorAll('.append-calced-economy')

    let pricePer = document.querySelectorAll('.price-per')
    let appendPricePer = document.querySelectorAll('.append-price-per')

    if(appendCalcedPrice.length) {
        for(let elem of appendCalcedPrice) {
            elem.textContent = totalPrice.toLocaleString() + ' ' + cur
        }
    }

    if(appendCalcedOldPrice.length) {
        for(let elem of appendCalcedOldPrice) {
            elem.textContent = totalOldPrice.toLocaleString() + ' ' + cur
        }
    }

    if(appendCalcedEconomy.length) {
        for(let elem of appendCalcedEconomy) {
            elem.textContent = '-' + totalEconomy.toLocaleString()
        }
    }

    if(appendPricePer.length) {
        for(let elem of appendPricePer) {
            elem.textContent = price.toLocaleString() + ' ' + cur
        }
    }

    if(pricePer.length) {
        for(let elem of pricePer) {
            if(quantity > 1) {
                elem.classList.add('show')
            } else {
                elem.classList.remove('show')
            }
        }
    }
}